module.exports = __webpack_public_path__ + "static/media/foreground.ce382891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameOceanCleanup/foreground.png
// module id = 2556
// module chunks = 0